import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Logout() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        localStorage.clear();
        const isMessenger = pathname.startsWith('/messenger');
        console.log('pathname:', pathname);
        console.log('isMessenger:', isMessenger);
        navigate(isMessenger ? '/login?mode=messenger' : '/login', { replace: true });
    }, []);

    return <React.Fragment></React.Fragment>;
};

export default Logout;